import { Grid, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Box } from '../../atoms/Box';
import { Typography } from '../../atoms/Typography';

export const RoleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'flush',
})<{ flush?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  ${({ flush }) =>
    flush
      ? ''
      : `
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  margin-bottom: 10px;
  `}
`;

export const StructureAddressAddGrid = styled(Grid)`
  margin-top: 4px;
`;

export const TableGridContainer = styled(Grid)`
  width: 100%;
`;

export const StyledTypography = styled(Typography)`
  margin-bottom: 10px;
`;

export const StyledTableRow = styled(TableRow)`
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;
